// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__WxSDN","l4":"styles_l4__DsKfY","redir":"styles_redir__XPTF+"};